import React from "react";

export default function Modal({ open, onClose, children }) {
    if (!open) return null;
    // Handler to close when clicking overlay
    function handleOverlayClick(e) {
        if (e.target === e.currentTarget) {
            onClose && onClose();
        }
    }
    return (
        <div
            role="dialog"
            aria-modal="true"
            data-modal-back="true"
            className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm"
            onClick={handleOverlayClick}
        >
            <div className="relative max-h-[90dvh] w-full min-w-0 max-w-[860px] overflow-hidden rounded-[28px] border border-white/60 bg-white p-0 shadow-[0_30px_90px_rgba(15,23,42,0.28)]">
                <button
                    data-modal-close
                    className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white/90 text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-slate-900"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ×
                </button>
                {children}
            </div>
        </div>
    );
}
